import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import asyncValidate from './asyncValidate';
import FormFieldsTabDates from '../../form-fields/tab-dates/tab-dates';
class AddEditViewReferralTabDates extends Component {
  render() {
    return (
      <div>
        <FormFieldsTabDates 
          {...this.props} 
          locked={this.props.locked} 
          referraloutcome={this.props.referraloutcome}
        />
      </div>
    );
  }
}
AddEditViewReferralTabDates.propTypes = {
  locked: PropTypes.bool,
}
AddEditViewReferralTabDates = reduxForm({
  form: 'ReferralEditForm', // a unique name for this form
  asyncValidate,
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(AddEditViewReferralTabDates);
export default AddEditViewReferralTabDates;